import { ActionSheetService } from './action-sheet.service';

declare let angular: ng.IAngularStatic;

export default angular
  .module('sfMobile.services.action-sheet', ['ionic'])
  .service('actionSheetService', ActionSheetService).name;
